import {
  onLCP,
  onCLS,
  onINP,
  MetricWithAttribution,
} from 'web-vitals/attribution';
import ga from '../helpers/ga';
import { lvtMetricEvent } from '.';

const sendMetricToAnalytics =
  (event: string, data: object) =>
  ({ attribution: debugInformation, ...metric }: MetricWithAttribution) =>
    ga.sendEvent(event, { ...metric, ...data, debugInformation });

export const trackWebVitals = (): void => {
  onLCP(
    sendMetricToAnalytics(
      ...lvtMetricEvent(
        'core_web_vitals',
        {},
        'lcp',
        undefined,
        'learning-platform'
      )
    )
  );
  onCLS(
    sendMetricToAnalytics(
      ...lvtMetricEvent(
        'core_web_vitals',
        {},
        'cls',
        undefined,
        'learning-platform'
      )
    )
  );
  onINP(
    sendMetricToAnalytics(
      ...lvtMetricEvent(
        'core_web_vitals',
        {},
        'inp',
        undefined,
        'learning-platform'
      )
    )
  );
};
